import { render, staticRenderFns } from "./LabProductChoice.vue?vue&type=template&id=4eb71913&scoped=true&"
import script from "./LabProductChoice.vue?vue&type=script&lang=ts&"
export * from "./LabProductChoice.vue?vue&type=script&lang=ts&"
import style0 from "./LabProductChoice.vue?vue&type=style&index=0&id=4eb71913&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb71913",
  null
  
)

export default component.exports